module.exports = __webpack_public_path__ + "img/spins_3.83084e49.png";